///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthPosition } from '../position';
import { PolygonFeatureView } from './view/polygon-feature-view';
import { GtthHistoryService } from '../../engine/history-service';
import { GtthStepGroupEnum, PositionDTO } from '../../../../generated/shared-types.model';

export class PolygonFeature {
    private view: PolygonFeatureView;
    private readonly polygonPath: google.maps.LatLngLiteral[];

    constructor(
        private readonly polygonIndex: number,
        path: PositionDTO[],
        private readonly historyService: GtthHistoryService
    ) {
        this.polygonPath = path.map((pathPoint) => {
            return {
                lat: pathPoint.latitude,
                lng: pathPoint.longitude
            };
        });
    }

    restoreDefaultOptions() {
        this.view.restoreDefaultOptions();
    }

    overrideOptions(options: google.maps.PolygonOptions) {
        this.view.setOptions(options);
    }

    getPolygonIndex(): number {
        return this.polygonIndex;
    }

    draw(): void {
        if (this.view) {
            return;
        }

        this.view = new PolygonFeatureView(this.historyService, this.polygonIndex, this.polygonPath);
        this.view.draw();
        this.initListeners();
    }

    hide() {
        if (this.view) {
            this.destroyListeners();
            this.view.hide();
            this.view = null;
        }
    }

    getPath() {
        return this.polygonPath.map((point) => {
            return {
                latitude: point.lat,
                longitude: point.lng
            };
        });
    }

    initListeners() {
        this.view.registerRightClickListener((event: google.maps.MapMouseEvent) => {
            this.historyService.ngZone.run(() => {
                this.showInfoWindow(GtthPosition.fromEventObject(event));
            });
        });
    }

    destroyListeners() {
        this.view.destroyListeners();
    }

    showInfoWindow(position?: GtthPosition) {
        if (this.historyService.isEditModeEnabled && this.historyService.selectedStepNumber === GtthStepGroupEnum.LOCATIONS_AND_LOSES) {
            this.historyService.clearSelectionCloseWindowAndArea();
            this.view.select();
            this.historyService.infoWindowsService.openSelectAreaStationInfoWindow(position, this.polygonIndex);
        }
    }

    select() {
        this.view.select();
    }

    unselect() {
        this.view.unselect();
    }
}
